// utils/dateHelpers.js
export function getMonthObject(date = new Date()) {
  const year = date.getFullYear();
  const month = date.getMonth(); 

  const start = new Date(year, month, 1).toISOString().split("T")[0];
  const end = new Date(year, month + 1, 0).toISOString().split("T")[0];

  const monthLabel = date.toLocaleString("default", { month: "short" });
  const shortYear = year.toString().slice(-2);

  return {
    id: `${start}|${end}`,
    label: `${monthLabel} ${shortYear}`,
  };
}
